import React from "react";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Divider from "@material-ui/core/Divider";
import LoanData from "../../../components/loanData";
import {Checkbox} from "@material-ui/core";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";

const RestrictionGuaranteeSelection = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TitlePage title="Tablero de Control \ Selección de Garantías"/>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container spacing={2} justify="flex-end">
                            <Grid item>
                                <Button label="Regresar" onClick={props.handleReturnButton}
                                        className="p-button-secondary"/>
                            </Grid>
                            <Grid item>
                                <Button label="Guardar" onClick={props.updateGuaranteeSelectionRestriction}/>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                    <LoanData
                        loanId={props.loanId}
                        selectedLoan={props.selectedLoan}
                        loading={props.loading}
                    />
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <SubtitleLabel header="Excepción" isBold={true}/>
                            <Checkbox
                                name="isRestricted"
                                checked={props.isRestricted}
                                onChange={props.saveCheck}/>
                            <label htmlFor="cb1" className="p-checkbox-label">Selección de Garantías</label>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default RestrictionGuaranteeSelection;